import script from "./ConfigGatewayModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigGatewayModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfigGatewayModal.vue?vue&type=style&index=0&id=305a3e58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-305a3e58"]])

export default __exports__